


import { Component, Vue } from 'vue-property-decorator';
import CompleteStep from '@/utils/mixins/completeStep';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import SummaryNavigation from './components/SummaryNavigation/index.vue';
import { namespace } from 'vuex-class';
import { Location } from 'vue-router';
import { TransitionDirection } from '../../store/modules/transitions';
import PageRouter from '../../components/PageRouter/index.vue';
import { Summary as SummaryInfo } from '@/utils/api';
import SimpleRoundedLoader from '../../components/utils/SimpleRoundedLoader/index.vue';

const appModule = namespace('app');
const configurationModule = namespace('configuration');
const summaryModule = namespace('summary');
const notifyModule = namespace('notify');

@Component({
  mixins: [CompleteStep, PageTransitionMode],
  components: {
    SummaryNavigation,
    PageRouter,
    SimpleRoundedLoader
  }
})
export default class Summary extends Vue {
  @summaryModule.State private routes!: Location[];
  @summaryModule.State private info!: SummaryInfo;
  @appModule.State private fontsLoaded!: boolean;

  @notifyModule.Action private openCodeModal!: () => void;
  @configurationModule.Action private getPDF!: (code: string) => string;

  private pdfLoading = false;
  private currentRouteIndex = 0;
  private transitionDirection: TransitionDirection = TransitionDirection.Forward;

  private async openPDF(event: Event) {
    event.preventDefault();

    this.pdfLoading = true;

    const PDFUrl: string = await this.getPDF(this.info.configuration.baufritzCode);

    this.$gtm.trackConfigurationPrint();

    this.pdfLoading = false;

    if (PDFUrl) {
      const a = document.createElement('a');

      a.style.display = 'none';
      // this breaks iOS Safari and I don't know why or how to fix it.
      // a.target = '_blank';
      a.href = PDFUrl;
      a.setAttribute('download', `${this.info.configuration.baufritzCode}.pdf`);

      document.body.appendChild(a);

      a.click();

      // Firefox hack with setTimeout
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(PDFUrl);
      }, 100);
    }
  }

  private onNavigation(params: { link: Location; index: number }) {
    this.transitionDirection =
      params.index >= this.currentRouteIndex ? TransitionDirection.Forward : TransitionDirection.Back;
    this.currentRouteIndex = params.index;

    this.$router.push(params.link);
  }
}
